export const banditDead = new Image();
banditDead.src = "assets/characterSprites/bandit/HeavyBanditReverse.png";
banditDead.width = 48;
banditDead.height = 48;
banditDead.yOffset = 95;
banditDead.xOffset = 200;
banditDead.cycleLoop = [0,1,2,3,4,5,6,7];